module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic9.de93fdc.woff2";